<template>
  <v-container fluid color="white--text">
    <v-card flat>
      <v-card-text>
        <v-tabs
            v-model="tab"
            background-color="primary"
            color="basil"
            grow
            centered
            dark
            icons-and-text
        >
          <v-tab
              v-for="item in items"
              :key="item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item key="Request Parameters"
          >
            <v-card
                color="basil"
                flat
            >
              <v-card-text>
                <v-card flat>
                  <v-card-title>Beneficiary Onboarding</v-card-title>
                  <v-card-text>
                    With the SasaPay Wallet as a Service (WaaS) you can onboard beneficiaries allowing them to have a seamless, safe, and secure way of making payments and completing transactions. When onboarding beneficiaries, you need to make two post requests, whereby the first one allows sending of a Confirmation Code to the beneficiary in order to verify that the registering beneficiary is the holder of the mobile number. The second post request for finalizing the registration of the beneficiary includes two additional parameters, the ConfirmationCode and requestId parameters.
                  </v-card-text>
                  <v-divider/>
                  <v-card-text>
                    EndPoints:<br/>
                    <div class="secondary pa-5" style="color: #e7e3fc">
                      <strong>Sandbox</strong>
                      <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/waas/customer-registration/"}}</p>
                    </div>
                  </v-card-text>
                  <v-divider/>
                  <v-card-text>
                    Request Parameters <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon> Change <code>MerchantCode</code> to your <code>{{"MERCHANT_CODE"}}</code> <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon>  <code>FirstName</code>  <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon> <code>MiddleName</code><br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon>  <code>LastName</code> <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon>  <code>MobileNumber</code> <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon>  <code>DocumentType</code><br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon>  <code>CountryCode</code> <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon>  <code>MobileNumber</code> <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon>  <code>Email</code> <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon>  <code>DocumentNumber</code> <br/>
                    <v-icon color="primary">mdi-access-point-check</v-icon>  <code>CallbackUrl</code> <br/>

                  </v-card-text>
                  <v-divider/>
                  <v-card-text>
                    Expected Results:<br/>

                    Sasa<span class="red--text">Pay</span> returns the response status with a detailed message.
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="Sample Request"
          >
            <v-card
                color="basil"
                flat
            >
              <v-card-text>
                <code-editor
                    :read_only="true"
                    theme="dark"
                    v-model="code"
                    @lang="changeLanguage"
                    :wrap_code="false"
                    :language_selector="true"
                    class="github_dark"
                    :copy_code="true"
                    font_size="14px"
                    width="100%"
                    :languages="[['php','PHP'],['java','Java'],['python', 'Python'],['javascript', 'Node Js']]"
                ></code-editor>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="Sample Response"
          >
            <v-card
                color="basil"
                flat
            >
              <v-card-text>
                <code-editor
                    :read_only="true"
                    theme="dark"
                    v-model="response"
                    :wrap_code="false"
                    :language_selector="true"
                    class="github_dark"
                    :copy_code="true"
                    font_size="14px"
                    width="100%"
                    :languages="[['json','JSON']]"
                ></code-editor>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import {
  waasBeneficiaryOnboardingRequest,
  waasBeneficiaryOnboardingResponse
} from "../../../../../shared/snippets/waas/onboarding/waasOnboarding";

export default {
  name: "BeneficiaryOnboarding",
  data: () =>({
    selectedLanguage:"",
    code:"",
    response:"",
    tab: null,
    items: [
      'Request Parameters', 'Sample Request','Sample Response',
    ],
  }),

  mounted() {
    this.importSnippets('php')//
    this.importResponse()
  },
  methods:{
    importSnippets(lang){
      this.code=waasBeneficiaryOnboardingRequest(lang)
    },
    importResponse(){
      this.response=waasBeneficiaryOnboardingResponse()
    },
    changeLanguage(val) {
      this.importSnippets(val)
    }
  }
}
</script>

<style scoped>
.basil--text {
  color: #356859 !important;
}
</style>